<script lang="ts" setup>
import type { TabsPaneContext } from 'element-plus'

import { sdTabsProps } from './tabs'
import { computed    } from 'vue'
import { useVModel   } from '@vueuse/core'
import { tabsEmits, ElTabs, ElTabPane } from 'element-plus'

defineOptions({ name: 'SdTabs' })
const props = defineProps(sdTabsProps)
const emit  = defineEmits(tabsEmits)

const bindValue = useVModel(props, 'modelValue', emit)

// 确保 label, value 含有默认值
const prop$ = computed(() => {
    return {
        ...props?.prop,
        label : props.prop && props.prop['label'] || 'label',
        value : props.prop && props.prop['value'] || 'value',
        count : props.prop && props.prop['count'] || 'count'  
    }   
})

const onTabClick = (tabPane: TabsPaneContext, ev: Event) => {
    emit('tab-click', tabPane, ev)
}

const onEdit = (paneName: string | number | null, action: 'remove' | 'add') => {
    emit('edit', paneName, action)
}   
</script>

<template>
    <ElTabs
        v-model="bindValue"
        :type="props.type"
        :closable="props.closable"
        :addable="props.addable"
        :editable="props.editable"
        :tab-position="props.tabPosition"
        :stretch="props.stretch"
        :before-leave="props.beforeLeave"
        @tab-click="onTabClick"
        @tab-remove="$emit('tab-remove', $event)"
        @tab-add="$emit('tab-add')"
        @edit="onEdit"
    >
        <ElTabPane 
            v-for="item in props.options"
            :key="item[prop$.value]"
            :label="item[prop$.label] + (item[prop$.count] ? ` (${ item[prop$.count] })` : '')"
            :disabled="item.disabled"
            :name="item[prop$.value]"
            :closable="item.closeable"
            :lazy="item.lazy"
        />
    </ElTabs>
</template>
